var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoxbetCasino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: 31
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.75317 0 0 .68664 11.878 2.191)",
    stroke: "#fff",
    xmlSpace: "preserve",
    textAnchor: "start",
    letterSpacing: 0.05,
    fontWeight: 400,
    fontSize: 24,
    fontFamily: "Proxima Nova',Arial, Helvetica, sans-serif;",
    id: "svg_5",
    y: 25.856,
    x: 35.696,
    strokeWidth: 0,
    fill: "#fff"
  }, "Casino"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_8",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_9",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_12"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M23.26 5.877H7.766c-1.217 0-2.213.914-2.213 2.032V22.13c0 1.118.996 2.032 2.213 2.032H23.26c1.217 0 2.213-.914 2.213-2.032V7.91c0-1.118-.996-2.032-2.213-2.032zM10.533 21.114c-.919 0-1.66-.68-1.66-1.523 0-.844.741-1.524 1.66-1.524.918 0 1.66.68 1.66 1.524 0 .843-.742 1.523-1.66 1.523zm0-9.142c-.919 0-1.66-.68-1.66-1.524 0-.843.741-1.524 1.66-1.524.918 0 1.66.681 1.66 1.524s-.742 1.524-1.66 1.524zm4.98 4.571c-.92 0-1.66-.68-1.66-1.524 0-.843.74-1.523 1.66-1.523.918 0 1.66.68 1.66 1.523 0 .844-.742 1.524-1.66 1.524zm4.979 4.571c-.919 0-1.66-.68-1.66-1.523 0-.844.741-1.524 1.66-1.524.918 0 1.66.68 1.66 1.524 0 .843-.742 1.523-1.66 1.523zm0-9.142c-.919 0-1.66-.68-1.66-1.524 0-.843.741-1.524 1.66-1.524.918 0 1.66.681 1.66 1.524s-.742 1.524-1.66 1.524z",
    id: "svg_13"
  }))))))))));
}
SvgFoxbetCasino.displayName = 'FoxbetCasino';
export default SvgFoxbetCasino;